import { FormControl } from '@angular/forms';

import { LogbookApproach } from './logbook-approach.model';

export class LogbookApproachForm {
  logbookApproachId: FormControl;
  airport: FormControl;
  runway: FormControl;
  isEVS: FormControl;
  // FKs
  logbookId: FormControl;
  approachTypeId: FormControl;
  // index signature
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any

  constructor(approach?: LogbookApproach) {
    if (!approach) {
      approach = new LogbookApproach();
    }

    this.logbookApproachId = new FormControl(approach.logbookApproachId);
    this.airport = new FormControl(approach.airport);
    this.runway = new FormControl(approach.runway);
    this.isEVS = new FormControl(approach.isEVS);
    // FKs
    this.approachTypeId = new FormControl(approach.approachTypeId);
    this.logbookId = new FormControl(approach.logbookId);
  }
}
